import {
  Button,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Stack,
  Divider,
} from '@chakra-ui/react'
import React, { FC } from 'react'
import { resetCamera, toggleAutoRotate } from '../utils/commonLib/camera'
import { generateJSON, togglePBR } from '../utils/design/customization'
import { exportVariant } from '../utils/import-export'
import { toggleFloor } from '../utils/objectUtils'
import { toggleInspector } from '../utils/commonLib/scene'
import { SkyBox } from './SkyBox'
import DesignsList from './devtools/DesignsList'
import ModelsList from './devtools/ModelsList'

export const DevTools: FC = () => {
  return (
    <div>
      <Tabs>
        <TabList>
          <Tab>Dev Tools</Tab>
          <Tab>Designs</Tab>
          <Tab>Models</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Stack spacing={2}>
              <Button size="sm" onClick={() => toggleInspector()}>
                Toggle inspector
              </Button>
              <Button size="sm" onClick={() => toggleAutoRotate()}>
                Toggle auto rotate
              </Button>
              <Button size="sm" onClick={() => resetCamera()}>
                Reset camera
              </Button>
              <Button size="sm" onClick={() => toggleFloor()}>
                Toggle floor
              </Button>
              <Button size="sm" onClick={() => exportVariant()}>
                Export variant (JSON)
              </Button>

              <Divider />

              <Button size="sm" onClick={() => togglePBR(false)}>
                Disable Refrection PBR
              </Button>
              <Button size="sm" onClick={() => togglePBR(true)}>
                Enable Refrection PBR
              </Button>

              <SkyBox />

              <Button size="sm" onClick={() => generateJSON()}>
                Generate JSON
              </Button>
            </Stack>
          </TabPanel>
          <TabPanel>
            <DesignsList />
          </TabPanel>
          <TabPanel>
            <ModelsList />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  )
}
